import { useRequest } from '@features/request/useRequest';
import type { CatalogLimitedCostTypeInput } from '@gql/graphql';

import { useDebounce } from '@consta/uikit/useDebounce';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import type { TCheckIsUniqueProps } from '../../CatalogOthersType/hooks';
import { isUniqueLimitedNameGql } from '../CatalogLimitedTypeQueries';

export const useCheckIsUniqueLimitedName = ({ name, methodology, isInputChanged }: TCheckIsUniqueProps) => {
    const dispatch = useDispatch();

    const variables: CatalogLimitedCostTypeInput = useMemo(
        () => ({
            name: name ?? '',
            methodology,
        }),
        [methodology, name],
    );

    const [data, , , request] = useRequest({
        requestId: 'isUniqueLimitedCostTypeName',
        query: isUniqueLimitedNameGql,
        withEffect: false,
    });

    const debounceRequest = useDebounce(() => {
        dispatch(request({ input: variables }));
    }, 300);

    const isValidInputValue = useMemo(() => {
        if (isInputChanged === undefined) {
            return true;
        }

        return isInputChanged;
    }, [isInputChanged]);

    useEffect(() => {
        if (isValidInputValue && name?.trim().length) {
            debounceRequest();
        }
    }, [debounceRequest, isValidInputValue, name]);

    return useMemo(
        () => ({ isUniqueName: data?.isUniqueLimitedCostType?.result }),
        [data?.isUniqueLimitedCostType?.result],
    );
};
